export const BRAND_NAME = "許文彰｜幸福人才";
export const COMPANY_NAME = "富悅商務發展有限公司";
export const PERSON_NAME = "許文彰";
export const JOB_TITLE = "幸福人才總教練";
export const METHOD_NAME = "幸福人才養成系統";

export function siteUrl(path = "") {
  const base = typeof window !== "undefined" ? window.location.origin : "";
  return `${base}${path}`;
}

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: COMPANY_NAME,
  url: siteUrl("/"),
  founder: {
    "@type": "Person",
    name: PERSON_NAME,
    jobTitle: JOB_TITLE,
  },
  description:
    "整合工程、企業管理與人才培育經驗，提供幸福人才養成系統、個人成長與企業培訓服務。",
};

export const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: BRAND_NAME,
  url: siteUrl("/"),
  inLanguage: "zh-Hant",
};

export const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: PERSON_NAME,
  jobTitle: JOB_TITLE,
  worksFor: { "@type": "Organization", name: COMPANY_NAME },
  description:
    "幸福人才總教練，擁有 30 年以上工程、企業管理、問題診斷、流程改善與人才培育的實務經驗，發展出幸福人才養成系統。",
  knowsAbout: [METHOD_NAME, "企業管理", "人才培育", "個人成長", "流程改善"],
};

export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "企業與團隊培訓",
  provider: { "@type": "Organization", name: COMPANY_NAME },
  areaServed: "TW",
  description:
    "涵蓋主管與領導、目標與團隊執行、自我與工作管理、人才培育與學習轉化四大議題，讓培訓真正回到工作現場。",
};

export const contactPageSchema = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: "聯絡許文彰",
  url: siteUrl("/contact"),
};

export function faqPageSchema(faq: { q: string; a: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}